import { rootStore } from '@models/Root';
import {
  HandleTimeSlotConfigurationSubmitArgs,
  saveTimeSlotConfiguration,
  TimeSlotConfigurationsDataType,
} from '@modules/timetable';
import { refreshTimetable } from '@models/Timetable/functions/refreshTimetable';
export const handleTimeSlotConfigurationSubmit = ({
  handleSubmit,
  applyToAll,
  addToast,
  batchId,
  setTimeSlotsConfigurationVisible,
  saveAsDefault,
}: HandleTimeSlotConfigurationSubmitArgs) => {
  handleSubmit((data) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { setTimeSlotConfiguration, week } = rootStore.timetable;

    // To the database
    saveTimeSlotConfiguration({
      timeSlotConfigurationsData: data as TimeSlotConfigurationsDataType,
      applyToAll,
      addToast,
      week,
      batchId,
      saveAsDefault,
    }).then(()=>{
     refreshTimetable()
    });

    setTimeSlotConfiguration({
      timeSlotConfigurationsData: data as TimeSlotConfigurationsDataType,
      applyToAll,
    });

    setTimeSlotsConfigurationVisible(false);
  })();
};
